import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 60000,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("gf_token");
      localStorage.removeItem("gf_user");
    }
    return Promise.reject(err);
  }
);

export function currency(v) {
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD", maximumFractionDigits: 0,
  }).format(v || 0);
}

export function daysUntil(iso) {
  const d = new Date(iso);
  const now = new Date();
  return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
}

export function computeMatch(grant, user) {
  if (!user) return 55;
  let score = 50;
  const orgType = user.org_type || "";
  if (grant.eligibility?.includes(orgType)) score += 30;
  if (grant.featured) score += 5;
  const days = daysUntil(grant.deadline);
  if (days > 20 && days < 90) score += 10;
  if (days < 10) score -= 5;
  return Math.max(20, Math.min(99, score));
}
